import templateUrl from './auth.html';

export default {
  templateUrl,
  bindings: {
    layout: '@',
    flex: '@'
  },
  controller: class AuthComponent {
    constructor() {
      'ngInject';
    }

    getBackgroundImage() {
      const imagePaths = [
        'images/background-horse.jpg',
        'images/background-dog.jpg',
        'images/background-cat.jpg'
      ];

      const randomImage = imagePaths[Math.floor(Math.random() * imagePaths.length)];
      return randomImage;
    }
  }
};



// WEBPACK FOOTER //
// ./components/auth/auth.component.js